import React from "react";
import _ from "lodash";
import ApiClient from "../../../services/ApiClient";
import FileSection from "./FileSection";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys, updateResource } from "../../../services/ReactQuery/reactQueryService";
import ProcessCostSupport from "../../../types/ProcessCostSupport";

type ProcessCostSupportFileSectionProps = {
  headline: string;
  description: string;
  processCostSupport: ProcessCostSupport;
  fieldname: string;
  setMediaObjectToDisplay: Function;
};

const ProcessCostSupportFileSection = ({
  headline,
  description,
  processCostSupport,
  fieldname,
  setMediaObjectToDisplay,
}: ProcessCostSupportFileSectionProps) => {
  const queryClient = useQueryClient();

  const updateMutation = useMutation({
    mutationFn: updateResource,
    onSuccess: (data, variables) => queryClient.setQueryData(queryKeys.item(variables.uri, data.id), data)
  });

  const deleteFile = async (id: number) => {
    let receipts = _.merge({}, processCostSupport.receipts);
    receipts[fieldname] = _.filter(receipts[fieldname], (mediaObject) => {
      return mediaObject.id !== id;
    });

    await updateMutation.mutateAsync({
      uri: "process_cost_supports",
      id: processCostSupport.id,
      data: { receipts: receipts },
    });
  };

  const uploadFile = async (files: File[]) => {
    let formData = new FormData();
    formData.append("file", files[0]);
    formData.append("product", "processCostSupport");
    formData.append("description", description);
    formData.append("fieldname", fieldname);
    formData.append("customerId", processCostSupport.customer.id.toString());

    let headers = new Headers();
    headers.set("Content-Type", "multipart/form-data");
    const mediaObject = await ApiClient.post("media_objects", {
      headers: headers,
      body: formData,
    });

    let receipts = { ...processCostSupport.receipts };
    const sectionReceipts = receipts[fieldname] || [];
    let mutableSectionReceipts = [...sectionReceipts];
    if (!mediaObject.status) {
      mutableSectionReceipts.push(mediaObject);
    }
    receipts[fieldname] = mutableSectionReceipts;

    await updateMutation.mutateAsync({
      uri: "process_cost_supports",
      id: processCostSupport.id,
      data: { receipts: receipts },
    });
  };

  return (
    <FileSection
      currentMediaObjects={processCostSupport.receipts[fieldname]}
      uploadFile={uploadFile}
      deleteFile={deleteFile}
      headline={headline + " [" + description + "]"}
      setMediaObjectToDisplay={setMediaObjectToDisplay}
    />
  );
};

export default ProcessCostSupportFileSection;
